import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=c8925c8a&scoped=true"
import script from "./NoData.vue?vue&type=script&lang=js"
export * from "./NoData.vue?vue&type=script&lang=js"
import style0 from "./NoData.vue?vue&type=style&index=0&id=c8925c8a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8925c8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8925c8a')) {
      api.createRecord('c8925c8a', component.options)
    } else {
      api.reload('c8925c8a', component.options)
    }
    module.hot.accept("./NoData.vue?vue&type=template&id=c8925c8a&scoped=true", function () {
      api.rerender('c8925c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NoData.vue"
export default component.exports